import React from "react";
import { motion } from "framer-motion";

// Update these paths if the images are located elsewhere in the assets directory
import selva1 from "../../assets/selva1.jpeg";
import selva2 from "../../assets/selva2.jpeg";
import selva3 from "../../assets/selva3.jpeg";

const MentoringBeyond = () => {
  return (
    <section className="bg-white py-16 px-4">
      <div className="max-w-7xl mx-auto text-center">
        {/* Title */}
        <motion.h2
          className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4"
          initial={{ opacity: 0, y: -40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
          viewport={{ once: true }}
        >
          Mentoring <span className="text-red-700">Beyond the Academy</span>
        </motion.h2>

        {/* Subtitle */}
        <motion.p
          className="text-base sm:text-lg text-gray-600 mb-12 max-w-3xl mx-auto"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
          viewport={{ once: true }}
        >
          At Selva's IAS Academy, our commitment to guiding students extends beyond our academy walls. 
          We actively engage in mentoring programs at esteemed institutions like 
          <span className="font-semibold text-blue-900"> Sona College of Engineering</span>, 
          empowering a wider community of students to realize their full potential and achieve their dreams.
        </motion.p>

        {/* Image Grid */}
        <div className="grid gap-6 sm:grid-cols-3">
          <motion.div
            className="rounded-xl overflow-hidden shadow-lg border-2 border-transparent hover:border-red-700 transition"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: "easeOut", delay: 0.1 }}
            viewport={{ once: true }}
          >
            <img 
              src={selva1} 
              alt="Mentoring session at Sona College of Arts and Science" 
              className="w-full h-64 object-cover object-center hover:scale-105 transition-transform duration-500"
            />
          </motion.div>

          <motion.div
            className="rounded-xl overflow-hidden shadow-lg border-2 border-transparent hover:border-red-700 transition"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: "easeOut", delay: 0.3 }}
            viewport={{ once: true }}
          >
            <img 
              src={selva2} 
              alt="Seminar at Sona College of Engineering" 
              className="w-full h-64 object-cover object-center hover:scale-105 transition-transform duration-500"
            />
          </motion.div>

          <motion.div
            className="rounded-xl overflow-hidden shadow-lg border-2 border-transparent hover:border-red-700 transition"
            initial={{ opacity: 0, y: 50 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: "easeOut", delay: 0.5 }}
            viewport={{ once: true }}
          >
            <img 
              src={selva3} 
              alt="Guidance program at Sona College of Arts and Science" 
              className="w-full h-64 object-cover object-center hover:scale-105 transition-transform duration-500"
            />
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default MentoringBeyond;
